import React from 'react'
import PropTypes from 'prop-types'
import { reduxForm } from 'redux-form'
import ReduxFormInput from 'components/ReduxFormInput'

const NetlifyForm = (props) => {
  const { render, method, formName, onSubmit, className, style } = props

  if (!formName) {
    throw new Error('You need to provide a name for the form')
  }
  if (typeof onSubmit !== 'function') {
    throw new Error('Please provide an onSubmit handler')
  }
  if (typeof render !== 'function') {
    throw new Error('You need to implement the render() prop as a function')
  }

  const Form = (props) => {
    const { children, handleSubmit, submitting } = props
    return (
      <form
        onSubmit={handleSubmit(onSubmit)}
        method={method || 'post'}
        name={formName}
        className={className}
        style={{ opacity: submitting ? 0.4 : 1, ...style }}
        data-netlify="true"
        data-netlify-honeypot="bot-field"
      >
        <input type="hidden" name="form-name" value={formName} />
        {children}
      </form>
    )
  }

  const FormWithReduxForm = reduxForm({
    method: method || 'post',
    formName,
    onSubmit,
  })(Form)

  return render({
    Form: FormWithReduxForm,
    Input: ReduxFormInput,
    TextArea: (props) => <ReduxFormInput {...props} multiline />,
  })
}

NetlifyForm.propTypes = {
  render: PropTypes.func.isRequired,
  method: PropTypes.string,
  formName: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
}

export default NetlifyForm



// WEBPACK FOOTER //
// ./src/components/forms/NetlifyForm.js